// update rank
// import ref from './_state';
/*
labels: {
    headerButtons: ['X', 'PREV', 'NEXT'],
    inputPlaceholder: 'Type university name',
    squareVc: {
        title: 'Vice-chancellor:',
        button: 'VC pay (£):'
    },
    squareComparisons: {
        subtitle: 'Comparisons:',
        title: 'Score in the THE World University Rankings 2015: ',
        buttons: ['Avg. salary:', 'REF:', 'NSS:', 'Students:']
    },
    footer: {
        title: 'NOTES:',
        note: 'Note that the figures quoted for VC salary reflects the total cost of the VC's office for 2014-15. In some cases, the figure includes a payoff to a previous VCs, inflating the total. For details on this, see our main VC pay table.'
    }
}
*/

export default function (sel, labels) {

    // append header
    const header = sel.append('header')
        .attr('id', 'typeahead-header')
    const typehead = header.append('div')
        .attr('class', 'inline-block')
        .attr('id', 'uni-selection')
    typehead.append('input')
        .attr('class', 'typeahead')
        .attr('type', 'text')
        .attr('placeholder', labels.inputPlaceholder)
    typehead.append('button')
        .attr('class', 'btn btn-small')
        .attr('id', 'js-typeahead-clear')
        .text(labels.headerButtons[0])
    const nav = header.append('nav')
        .attr('class', 'nav-next-prev')
    nav.append('button')
        .attr('class', 'btn btn-primary btn-small bg-cyan-light')
        .attr('id', 'js-prev')
        .text(labels.headerButtons[1])
    nav.append('button')
        .attr('class', 'btn btn-primary btn-small bg-cyan-light')
        .attr('id', 'js-next')
        .text(labels.headerButtons[2])

    // square chart wrap
    const squareCharts = sel.append('div')
        .attr('id', 'square-chart-wrap')
    // VC chart
    const squareVc = squareCharts.append('section')
        .attr('class', 'inline-block')
        .attr('id', 'square-chart-p1')
    squareVc.append('h4')
        .attr('class', 'subtitle')
        .text(labels.squareVc.title)
    squareVc.append('h3')
        .attr('id', 'js-vc-name')
    const squareVcChart = squareVc.append('div')
        .attr('class', 'square-chart-wrap')
        .attr('id', 'js-vc-pay')
    squareVcChart.append('button')
        .attr('class', 'btn btn-primary btn-small bg-none')
        .text(labels.squareVc.button)
    squareVcChart.append('section')
        .attr('class', 'square-chart')
        .attr('id', 'js-square0')
    // comparisons chart
    const squareComparisons = squareCharts.append('section')
        .attr('class', 'inline-block')
        .attr('id', 'square-chart-p2')
    squareComparisons.append('h4')
        .attr('class', 'subtitle')
        .text(labels.squareComparisons.subtitle)
    squareComparisons.append('h2')
        .attr('id', 'rank')
        .html(labels.squareComparisons.title + '<span id="js-rank"></span>')
    const squareSalary = squareComparisons.append('div')
        .attr('class', 'inline-block square-chart-wrap')
        .attr('id', 'js-salary')
    squareSalary.append('button')
        .attr('class', 'btn btn-primary btn-small js-btn-chart')
        .attr('id', 'js-btn-salary')
        .text(labels.squareComparisons.buttons[0])
    squareSalary.append('section')
        .attr('class', 'square-chart')
        .attr('id', 'js-square1')
    const squareRef = squareComparisons.append('div')
        .attr('class', 'inline-block square-chart-wrap')
        .attr('id', 'js-ref')
    squareRef.append('button')
        .attr('class', 'btn btn-primary btn-small js-btn-chart')
        .attr('id', 'js-btn-ref')
        .text(labels.squareComparisons.buttons[1])
    squareRef.append('section')
        .attr('class', 'square-chart')
        .attr('id', 'js-square2')
    const squareNss = squareComparisons.append('div')
        .attr('class', 'inline-block square-chart-wrap')
        .attr('id', 'js-nss')
    squareNss.append('button')
        .attr('class', 'btn btn-primary btn-small js-btn-chart')
        .attr('id', 'js-btn-nss')
        .text(labels.squareComparisons.buttons[2])
    squareNss.append('section')
        .attr('class', 'square-chart')
        .attr('id', 'js-square3')
    const squareStudents = squareComparisons.append('div')
        .attr('class', 'inline-block square-chart-wrap')
        .attr('id', 'js-students')
    squareStudents.append('button')
        .attr('class', 'btn btn-primary btn-small js-btn-chart')
        .attr('id', 'js-btn-students')
        .text(labels.squareComparisons.buttons[3])
    squareStudents.append('section')
        .attr('class', 'square-chart')
        .attr('id', 'js-square4')

    // append point series
    const pointSeries = sel.append('section')
        .attr('id', 'point-series')
        .attr('class', 'chart')
    pointSeries.append('h1')
        .attr('id', 'js-chart-title')
        .text('Loading')

    // append footer
    const footer = sel.append('footer')
    footer.append('h4')
        .attr('class', 'subtitle')
        .text(labels.footer.title)
    footer.append('h4')
        .attr('class', 'chart-note')
        .attr('id', 'js-chart-note-null')
    footer.append('h4')
        .attr('class', 'chart-note')
        .attr('id', 'js-chart-note')
    footer.append('h4')
        .attr('class', 'chart-note')
        .text(labels.footer.note)

}

/* DOM output: 
<div>
    <header id="typeahead-header">
        <div class="inline-block" id="uni-selection">
            <input class="typeahead" type="text" placeholder="Type university name">
            <button class="btn btn-small" id="js-typeahead-clear">X</button>
        </div>
        <nav class="nav-next-prev">
            <button class="btn btn-primary btn-small bg-cyan-light" id="js-prev">PREV</button>
            <button class="btn btn-primary btn-small bg-cyan-light" id="js-next">NEXT</button>
        </nav>
    </header>

    <div id="square-chart-wrap">
        <section class="inline-block" id="square-chart-p1">
            <h4 class="subtitle">Vice-chancellor:</h4>
            <h3 id="js-vc-name"></h3>
            <div class="square-chart-wrap" id="js-vc-pay">
                <button class="btn btn-primary btn-small bg-none">VC pay (£):</button>
                <section class="square-chart" id="js-square0"></section>
            </div>
        </section>
        <section class="inline-block" id="square-chart-p2">
            <h4 class="subtitle">Comparisons:</h4>
            <h2 id="rank">Score in the THE World University Rankings 2015: <span id="js-rank"></span></h2>
            <div class="inline-block square-chart-wrap" id="js-salary">
                <button class="btn btn-primary btn-small js-btn-chart" id="js-btn-salary">Avg. salary:</button>
                <section class="square-chart" id="js-square1"></section>
            </div>
            <div class="inline-block square-chart-wrap" id="js-ref">
                <button class="btn btn-primary btn-small js-btn-chart" id="js-btn-ref">REF:</button>
                <section class="square-chart" id="js-square2"></section>
            </div>
            <div class="inline-block square-chart-wrap" id="js-nss">
                <button class="btn btn-primary btn-small js-btn-chart" id="js-btn-nss">NSS:</button>
                <section class="square-chart" id="js-square3"></section>
            </div>
            <div class="inline-block square-chart-wrap" id="js-students">
                <button class="btn btn-primary btn-small js-btn-chart" id="js-btn-students">Students:</button>
                <section class="square-chart" id="js-square4"></section>
            </div>
        </section>
    </div>

    <section id="point-series" class="chart">
        <h1 id="js-chart-title">Loading</h1>
    </section>
    
    <footer>
        <h4 class="subtitle">NOTES:</h4>
        <h4 class="chart-note" id="js-chart-note-null"></h4>
        <h4 class="chart-note" id="js-chart-note"></h4>
        <h4 class="chart-note">Note that the figures quoted for VC salary reflects the total cost of the VC's office for 2014-15. In some cases, the figure includes a payoff to a previous VCs, inflating the total. For details on this, see our main VC pay table.</h4>
    </footer>
    
</div>
*/